import React, {useEffect} from 'react';
import {IonPage, IonContent} from '@ionic/react';
import NewsFilterTabs from '../components/NewsFilterTabs';
import NewsSnippetItem from '../components/NewsSnippetItem';
import NewsDetailCard from "../components/NewsDetailCard";
import {actionToGetCurrentLatestNewsCategories, actionToGetNewsById} from "../apiHelpers/CommonAction";
import useStore from "../zustand/useStore";
import {FacebookLoader} from "../components/Loader/FacebookLoader";
import {useParams} from "react-router";


export default function HomeDesktopPage({renderHeaderPage}) {
    const {requestNewsCategory,newsDetailsData,setNewsDetailsData,setNewsCategoryData,newsCategory,newsDetailDataList} = useStore();
    const {loading,newsDetailList} = newsDetailDataList;
    const {id} = useParams();

    useEffect(()=>{
        if(newsDetailList?.length && !id && !newsDetailsData?.id){
            setNewsDetailsData(newsDetailList[0]);
        }
    },[newsDetailList,id])

    useEffect(()=>{
        if(id) {
            actionToGetNewsById(id).then((newsData)=>{
                if(newsData?.id) {
                    setNewsDetailsData(newsData);
                }
            });
            setTimeout(()=>{
                window.history.pushState({},null,`${window.location.origin}/dashboard/home`);
            },1000)
        }
    },[id])

    const handleListClick = (news)=>{
        setNewsDetailsData(news);
    }

    useEffect(()=>{
        actionToGetCurrentLatestNewsCategories(requestNewsCategory,setNewsCategoryData);
    },[])

    return (
        <IonPage>
            {/*/////// RENDER HEADER PART ////////*/}
            {renderHeaderPage && renderHeaderPage()}
            {/*/////// RENDER HEADER PART ////////*/}
            <IonContent fullscreen className="news-page page-content off-white-background-content">
                <div className="news-wrapper two-grid-panel">
                    <div className="news-snippets-list-outer">
                        <NewsFilterTabs newsCategory={newsCategory} />
                        {loading ?
                            <div>
                                <FacebookLoader type={"facebookStyle"} item={4}/>
                            </div>
                            :
                            <div className="news-snippets-list">
                                {newsDetailList.map((item) => (
                                    <NewsSnippetItem key={item.id} selectedId={newsDetailsData?.id} newsData={item} handleListClick={handleListClick} />
                                ))}
                            </div>
                        }
                    </div>
                    <div className="news-snippets-detail">
                        <div className="news-snippets-detail-inner">
                            <NewsDetailCard newsDetailsData={newsDetailsData}/>
                        </div>
                    </div>
                </div>
            </IonContent>
        </IonPage>
    );
}
